export const ehLevels = ["EH2+", "EH3"];

export const secondFactors = ["SMS", "OTP"];

export const idTypes = ["Identiteitskaart", "Paspoort", "Rijbewijs"];
